
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneoutstationcab() {



  const cardData =
  {
    keyword: 'Pune Outstation Cabs',
    heading: 'AB Ghule Cabs: Pune Outstation Cabs',
    headingDescription: 'Planning an outstation trip from Pune? Choose AB Ghule Cabs for a comfortable, reliable, and hassle-free travel experience. Our outstation cab services are tailored to meet your travel needs, whether you are planning a weekend getaway, a business trip, or a family vacation. With a range of well-maintained vehicles and experienced drivers, we ensure a smooth and enjoyable journey every time.',

    top: 'Top Destinations to Explore with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Lonavala and Khandala",
          description: "Famous for their lush greenery, cascading waterfalls, and pleasant weather, Lonavala and Khandala are perfect for a quick escape from Pune. The twin hill stations are nestled in the Sahyadri range and offer picturesque views, especially during the monsoon season. Key attractions include Tiger's Leap, a breathtaking cliff-top view; Bhushi Dam, known for its seasonal waterfall; and Rajmachi Point, a trekking destination with views of the surrounding valleys and forts. Lonavala is also known for its chikki (a sweet snack), making it a popular food destination."
        },
        {
          title: "Mahabaleshwar",
          description: "A hill station known for its strawberry farms and panoramic views, Mahabaleshwar offers a cool climate and an escape from the hustle of city life. It is situated at an altitude of 1,353 meters and provides stunning vistas of the Sahyadri range and valleys below. Attractions like Arthur's Seat, offering spectacular views of the valleys, Venna Lake for boating, and Pratapgad Fort, which was built by Shivaji Maharaj, make it a must-visit for history and nature lovers. Mahabaleshwar is also famous for its fresh strawberries and homemade jams."
        },
        {
          title: "Mumbai",
          description: "The bustling city of Mumbai is a blend of culture, history, and modernity. Known as the financial capital of India, Mumbai is a city that never sleeps. Explore iconic landmarks such as the Gateway of India, Marine Drive, and Juhu Beach. The Gateway of India stands as a symbol of colonial grandeur, Marine Drive offers stunning views of the Arabian Sea, and Juhu Beach is perfect for an evening stroll with street food delicacies. The city's vibrant street food scene offers delights such as vada pav, pav bhaji, and bhel puri. Mumbai is also home to the Bollywood industry, and visiting Film City is a great way to experience the magic of Indian cinema."
        },
        {
          title: "Shirdi",
          description: "A spiritual hub, Shirdi is home to the famous Sai Baba Temple, attracting millions of devotees each year. The temple, built in honor of the revered saint Sai Baba, offers peace and spiritual solace to pilgrims. Visitors can also explore other sacred sites like the Samadhi Mandir, where Sai Baba's remains are preserved, and Dwarkamai, where he spent his final years. Shirdi’s peaceful ambiance and religious significance make it a perfect destination for those seeking spiritual enlightenment. The town is also known for its vibrant fairs and events, especially during Sai Baba’s death anniversary."
        },
        {
          title: "Goa",
          description: "Known for its stunning beaches, vibrant nightlife, and Portuguese heritage, Goa is the ultimate destination for relaxation and adventure. The state's beaches, such as Calangute, Anjuna, and Baga, are famous for their golden sands and water sports activities. Goa also boasts a rich colonial history, with landmarks like Fort Aguada, a 17th-century Portuguese fort, and Dudhsagar Falls, one of India's tallest waterfalls. Visitors can indulge in Goan cuisine, famous for its seafood and spicy flavors, and experience the lively nightlife at its clubs and beach shacks. Goa's unique blend of culture, history, and natural beauty makes it an unforgettable destination."
        },
        {
          title: "Kolhapur",
          description: "Known for its historical significance and delectable cuisine, Kolhapur is a city located in the southwest of Maharashtra. It is renowned for the Mahalakshmi Temple, dedicated to the goddess Lakshmi, which draws thousands of devotees every year. Rankala Lake offers a peaceful setting for boating and relaxation, while Panhala Fort, an ancient hill fort, offers panoramic views of the surrounding landscape. Kolhapur is also famous for its spicy Kolhapuri cuisine, including dishes like the famous Kolhapuri misal and the iconic Kolhapuri chappals."
        },
        {
          title: "Aurangabad",
          description: "A city of historical marvels, Aurangabad is a gateway to some of Maharashtra's most ancient and awe-inspiring landmarks. The Ajanta and Ellora Caves are UNESCO World Heritage Sites, showcasing magnificent rock-cut architecture and intricate sculptures that date back to ancient times. Bibi Ka Maqbara, often referred to as the 'Taj of the Deccan,' is a beautiful monument built in the memory of Aurangzeb's wife. Daulatabad Fort, another historical gem, offers a glimpse into the region's medieval past. Aurangabad is also famous for its Paithani sarees, known for their vibrant colors and intricate designs."
        },
        {
          title: "Ratnagiri",
          description: "A coastal paradise, Ratnagiri is known for its pristine beaches, Alphonso mangoes, and cultural heritage. The town is home to Ganpatipule Temple, an important pilgrimage site dedicated to Lord Ganesha, and Ratnadurg Fort, offering a stunning view of the Arabian Sea. The region's beaches, like Ganpatipule Beach, are perfect for a peaceful getaway, while the Alphonso mangoes grown here are world-famous for their sweetness and flavor. Ratnagiri’s relaxed atmosphere and natural beauty make it a great place to unwind and explore the local culture."
        },
        {
          title: "Nashik",
          description: "Known for its vineyards and religious importance, Nashik is a city that offers a blend of spirituality and natural beauty. It is famous for its Sula Vineyards, where visitors can enjoy wine tours and tastings. Nashik is also home to religious sites like Trimbakeshwar Temple, an important pilgrimage destination dedicated to Lord Shiva, and Panchvati, a place associated with the epic Ramayana. The city offers a perfect mix of culture, wine tourism, and spirituality, making it a unique destination in Maharashtra."
        },
        {
          title: "Satara",
          description: "Nestled in the Sahyadri range, Satara boasts scenic landscapes and historic forts. The Kaas Plateau, known for its wildflower blooms, is a UNESCO World Heritage Site and a paradise for nature lovers. Ajinkyatara Fort, located on a hilltop, offers panoramic views of the surrounding valleys and is a popular trekking destination. Thoseghar Waterfalls, with its cascading streams, is another must-visit spot for nature enthusiasts. Satara is an ideal destination for history buffs, nature lovers, and those looking for an offbeat experience."
        }
      ],      

   services: [
    {
      "name": "Pune Outstation Cab Services",
      description: "Travel comfortably and conveniently with AB Ghule Cabs’ Pune Outstation Cab Services. Whether you're heading to a nearby destination or a distant location, we offer reliable and affordable taxi services for all your outstation travel needs. Enjoy a hassle-free experience with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Pune Outstation Taxi Booking",
      description: "Booking an outstation taxi from Pune is simple and quick with AB Ghule Cabs. You can easily book your taxi online or over the phone, and choose from a variety of vehicles to suit your travel needs. We ensure a comfortable and timely journey to your destination."
    },
    {
      "name": "Pune Outstation Car Rental",
      description: "Looking for a car rental for your outstation trip from Pune? AB Ghule Cabs offers car rental services that allow you to travel at your own pace. Whether you're traveling solo or in a group, we have a wide range of vehicles to choose from, ensuring comfort and convenience throughout your journey."
    },
    {
      "name": "Pune Outstation Chauffeur-Driven Cabs",
      description: "Experience the convenience of a chauffeur-driven cab for your outstation trip from Pune. With AB Ghule Cabs, you’ll have a professional driver who is familiar with the routes, ensuring a smooth and relaxed ride. Travel stress-free with our reliable taxi services."
    },
    {
      "name": "Pune Outstation One-Way Taxi",
      description: "AB Ghule Cabs offers one-way taxi services for your outstation trips from Pune. Whether you're going on a business trip or a vacation, our one-way taxi option allows you to pay only for the distance traveled, making it a cost-effective choice for one-way travel."
    },
    {
      "name": "Pune Outstation Round Trip Cabs",
      description: "Our round-trip cabs are ideal for those who need to travel to an outstation destination and return to Pune. With AB Ghule Cabs, you can enjoy a comfortable, stress-free round-trip journey, with flexible departure times and vehicle options to suit your preferences."
    },
    {
      "name": "Pune Outstation Luxury Taxi",
      description: "For a more luxurious travel experience, choose our luxury outstation taxi services. AB Ghule Cabs offers high-end vehicles for those who want to travel in style and comfort. With premium amenities, our luxury taxis ensure that your outstation trip is as enjoyable as it is convenient."
    },
    {
      "name": "Pune Outstation Self-Drive Car Rental",
      description: "If you prefer to drive yourself, AB Ghule Cabs offers self-drive car rental services for your outstation trip. Rent a car from our fleet of well-maintained vehicles, and enjoy the freedom to explore your destination at your own pace, without any time constraints."
    },
    {
      "name": "Pune Outstation Travel Packages",
      description: "AB Ghule Cabs provides customizable travel packages for your outstation trips. Our packages include vehicle rental, driver charges, and sightseeing, offering a comprehensive solution for your travel needs. Choose a package that fits your schedule and budget."
    },
    {
      "name": "Pune Outstation Private Car Hire",
      description: "For a personalized travel experience, opt for a private car hire for your outstation journey. AB Ghule Cabs offers private car services where you can choose your preferred vehicle and travel with your group or family in comfort and privacy."
    },
    {
      "name": "Pune Outstation Cabs",
      description: "AB Ghule Cabs offers a wide range of outstation cabs from Pune, including sedans, SUVs, and luxury vehicles. Whether you're going on a short trip or a longer vacation, our outstation cabs are designed to make your journey safe, comfortable, and enjoyable."
    },
    {
      "name": "Outstation Taxi Service Pune",
      description: "For reliable and affordable outstation taxi services from Pune, AB Ghule Cabs is the perfect choice. We provide efficient taxi services to various destinations, ensuring that you travel in comfort with professional drivers and well-maintained vehicles."
    },
    {
      "name": "One Way Cab Pune",
      description: "If you're looking for a one-way cab service from Pune to an outstation, AB Ghule Cabs provides affordable and comfortable options. With transparent pricing and no hidden charges, our one-way taxi services offer great value for money."
    },
    {
      "name": "Best Outstation Cab Service in Pune",
      description: "AB Ghule Cabs is known for providing the best outstation cab services in Pune. We pride ourselves on offering reliable, timely, and affordable services, ensuring that your outstation journey is smooth and hassle-free."
    },
    {
      "name": "Outstation Cab Service in Pune",
      description: "Travel to your desired outstation destination with ease by choosing AB Ghule Cabs. We offer a wide range of vehicles, including sedans, SUVs, and luxury cars, along with experienced drivers who ensure that you travel safely and comfortably."
    },
    {
      "name": "Outstation Car Rental Pune",
      description: "AB Ghule Cabs offers convenient outstation car rental services from Pune. Rent a car for your trip, and enjoy the flexibility of traveling at your own pace. Our fleet of well-maintained vehicles ensures that you have a comfortable and smooth journey."
    },
    {
      "name": "Taxi in Pune for Outstation",
      description: "If you need a taxi for your outstation trip from Pune, AB Ghule Cabs offers reliable and affordable taxi services. Whether you're traveling for business or leisure, our experienced drivers ensure a safe and comfortable ride."
    },
    {
      "name": "Taxi Service in Pune for Outstation",
      description: "AB Ghule Cabs offers exceptional taxi services for your outstation journey from Pune. With a fleet of well-maintained cars and professional drivers, we provide a smooth and enjoyable travel experience to your desired destination."
    },
    {
      "name": "Book Outstation Cabs Pune",
      description: "Booking an outstation cab from Pune is easy with AB Ghule Cabs. Our user-friendly booking system allows you to reserve your ride quickly and easily, ensuring a hassle-free travel experience from Pune to your chosen outstation destination."
    },
    {
      "name": "Cab Booking in Pune for Outstation",
      description: "AB Ghule Cabs provides a seamless cab booking experience for your outstation trips from Pune. Book your cab online or over the phone, and travel in comfort with our reliable taxi services."
    },
    {
      "name": "Outstation Taxi in Pune",
      description: "For reliable and affordable outstation taxi services in Pune, AB Ghule Cabs is the best choice. We provide a wide variety of vehicles to suit your travel needs and ensure that you have a safe and comfortable journey."
    },
    {
      "name": "Outstation Taxi Service in Pune",
      description: "If you need a taxi service for an outstation trip from Pune, AB Ghule Cabs offers dependable and cost-effective options. Whether you're traveling solo or with a group, we have the perfect vehicle to accommodate your needs."
    },
    {
      "name": "Pune Airport to Kolhapur Cab",
      description: "AB Ghule Cabs offers taxi services from Pune Airport to Kolhapur. Whether you're traveling for business or leisure, our taxi services ensure that you reach Kolhapur comfortably and on time."
    },
    {
      "name": "Pune Car Rental Outstation",
      description: "AB Ghule Cabs provides car rental services for outstation trips from Pune. Rent a car from our fleet of vehicles, and explore your destination at your own pace, with the freedom to stop wherever you wish."
    },
    {
      "name": "Pune to Gokarna Cab",
      description: "Planning a trip to Gokarna? AB Ghule Cabs offers reliable taxi services from Pune to Gokarna. Travel comfortably and safely to this beautiful coastal destination with our professional drivers and well-maintained vehicles."
    },
    {
      "name": "Pune to Outstation Taxi",
      description: "AB Ghule Cabs offers dependable and affordable outstation taxi services from Pune to various destinations. Whether you're planning a weekend getaway or a longer trip, we provide safe and comfortable rides to your outstation destination."
    },
    {
      "name": "Pune Outstation Cabs Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune Outstation Cabs. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pune Outstation Cab Services", "-Pune Outstation Taxi Booking"],
    ["Pune Outstation Car Rental", "-Pune Outstation Chauffeur-Driven Cabs"],
    ["Pune Outstation One-Way Taxi", "-Pune Outstation Round Trip Cabs"],
    ["Pune Outstation Luxury Taxi", "-Pune Outstation Self-Drive Car Rental"],
    ["Pune Outstation Travel Packages", "-Pune Outstation Private Car Hire"],
    ["Pune Outstation Cabs", "-Outstation Taxi Service Pune"],
    ["Best Outstation Cab Service in Pune", "-Outstation Cab Service in Pune"],
    ["Outstation Car Rental Pune", "-Taxi in Pune for Outstation"],
    ["Taxi Service in Pune for Outstation", "-Book Outstation Cabs Pune"],
    ["Cab Booking in Pune for Outstation", "-Outstation Taxi in Pune"],
    ["Pune Airport to Kolhapur Cab", "-Pune Car Rental Outstation"],
    ["Pune to Gokarna Cab", "-Pune to Outstation Taxi"],
    ["Outstation Taxi Service in Pune", ""]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Comfortable Rides",
      WhyChoosedescription: "AB Ghule Cabs offers reliable outstation cab services from Pune to various destinations across Maharashtra and beyond. Whether it's a weekend getaway or a long-distance business trip, we ensure a comfortable and stress-free journey in well-maintained vehicles."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our team of highly experienced drivers is trained to handle outstation routes, ensuring you reach your destination safely and on time. With in-depth knowledge of roads and traffic conditions, they provide a smooth and hassle-free experience."
    },
    {
      WhyChooseheading: "Wide Range of Vehicles",
      WhyChoosedescription: "We offer a variety of vehicles for outstation travel, including sedans, SUVs, and luxury cars. Whether you're traveling solo, with family, or in a group, we have a vehicle to suit your needs and provide a comfortable travel experience."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "AB Ghule Cabs ensures competitive pricing for outstation travel. Our fares are transparent, with no hidden charges. We provide clear pricing at the time of booking, allowing you to plan your budget without any surprises."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether you're planning a last-minute trip or need an early morning departure, AB Ghule Cabs is available 24/7. We understand the need for flexibility and ensure our services are available whenever you need them."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "Our vehicles are regularly serviced and undergo thorough inspections to guarantee they are in excellent condition. Each vehicle is equipped with modern amenities, such as air-conditioning and GPS, to ensure a smooth, comfortable ride."
    },
    {
      WhyChooseheading: "Customizable Travel Plans",
      WhyChoosedescription: "We offer customizable travel plans to suit your schedule and preferences. Whether you need a one-way trip, round-trip, or multiple stops along the way, we are happy to tailor your travel experience to your needs."
    },
    {
      WhyChooseheading: "Customer Satisfaction",
      WhyChoosedescription: "Customer satisfaction is at the heart of our services. We take pride in offering prompt support, easy booking processes, and consistent service to ensure that your outstation trip is as pleasant and comfortable as possible."
    }
  ]
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How do I book an outstation cab with AB Ghule Cabs?',
      answer: 'You can book an outstation cab through our website, mobile app, or by calling our customer service. We provide a quick and easy booking process.',
    },
    {
      id: 'FAQ2',
      question: 'What types of vehicles are available for outstation travel?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars. Depending on your group size and preferences, we can suggest the most suitable vehicle for your trip.',
    },
    {
      id: 'FAQ3',
      question: 'Are the drivers experienced for long-distance trips?',
      answer: 'Yes, all our drivers are experienced and have extensive knowledge of outstation routes. They are professional, punctual, and ensure your safety and comfort during the journey.',
    },
    {
      id: 'FAQ4',
      question: 'Can I choose the pickup and drop locations?',
      answer: 'Yes, you can customize your pickup and drop locations. Whether it’s from your home, office, or any other location, we will make sure to accommodate your preferences.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for long-distance travel?',
      answer: 'Our pricing is transparent, and any additional charges for outstation trips will be discussed with you during booking. Charges for fuel, tolls, or overnight stays (if applicable) are clarified upfront.',
    },
    {
      id: 'FAQ6',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can modify or cancel your booking as per our cancellation policy. Please inform us at least 24 hours in advance to avoid cancellation charges.',
    },
    {
      id: 'FAQ7',
      question: 'How are the payment options for outstation cabs?',
      answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payments through our mobile app. You can choose the method that is most convenient for you.',
    },
    {
      id: 'FAQ8',
      question: 'Do you offer a return journey from outstation locations?',
      answer: 'Yes, we offer return journeys from outstation locations. You can book a round-trip service, and our team will ensure timely pickups for your return journey.',
    },
    {
      id: 'FAQ9',
      question: 'What is the duration for a typical outstation trip?',
      answer: 'The duration of your outstation trip will depend on the distance to your destination. Our drivers will keep you informed about the expected time of arrival and ensure you reach your destination safely and on time.',
    },
    {
      id: 'FAQ10',
      question: 'Why should I choose AB Ghule Cabs for my outstation travel?',
      answer: 'AB Ghule Cabs provides reliable, comfortable, and affordable outstation services. With experienced drivers, a wide range of vehicles, and a focus on customer satisfaction, we ensure that your journey is smooth and enjoyable.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Arvind Patel',
      feedback: 'I booked AB Ghule Cabs for a trip from Pune to Mumbai, and it was a great experience. The cab was clean, the driver was professional, and the ride was comfortable. I will definitely choose AB Ghule Cabs for my future outstation trips!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Mrs. Sunita Deshmukh',
      feedback: 'Our family took an outstation trip from Pune to Lonavala with AB Ghule Cabs. The entire experience was flawless. The driver was friendly, the vehicle was spacious, and we had a smooth journey. Highly recommend them for anyone looking for reliable outstation cab services.',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune Outstation Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Explore Pune Outstation Cab Services with AB Ghule Cabs. Offering one-way and round-trip bookings, luxury taxis, chauffeur-driven cabs, and affordable car rental options. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune Outstation Cab Services, Pune Outstation Taxi Booking, Pune Outstation Car Rental, Pune Outstation Chauffeur-Driven Cabs, Pune Outstation One-Way Taxi, Pune Outstation Round Trip Cabs, Pune Outstation Luxury Taxi, Pune Outstation Self-Drive Car Rental, Pune Outstation Travel Packages, Pune Outstation Private Car Hire, Pune Outstation Cabs, Outstation Taxi Service Pune, One Way Cab Pune, Best Outstation Cab Service in Pune, Outstation Cab Service in Pune, Outstation Car Rental Pune, Taxi in Pune for Outstation, Taxi Service in Pune for Outstation, Book Outstation Cabs Pune, Cab Booking in Pune for Outstation, Outstation Taxi in Pune, Outstation Taxi Service in Pune, Pune Airport to Kolhapur cab, Pune Car Rental Outstation, Pune to Gokarna Cab, Pune to Outstation Taxi" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune Outstation Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Explore Pune Outstation Cab Services with AB Ghule Cabs. Offering one-way and round-trip bookings, luxury taxis, chauffeur-driven cabs, and affordable car rental options. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-outstation-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-outstation-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune Outstation Cabs",
        description: "Explore Pune Outstation Cab Services with AB Ghule Cabs. Offering one-way and round-trip bookings, luxury taxis, chauffeur-driven cabs, and affordable car rental options. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-outstation-cabs",
        "logo": "https://abghulecabs.com/images/pune-outstation-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-outstation-cabs.jpg",
        "priceRange": "₹1000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-outstation-cabs",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "980"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vikram Deshpande"
            },
            "datePublished": "2024-11-28",
            "reviewBody": "Fantastic service for outstation cabs. The ride to Goa was comfortable, and the driver was very friendly."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rita Sharma"
            },
            "datePublished": "2024-11-20",
            "reviewBody": "Reliable and affordable outstation cab service. Booked a taxi to Mumbai and the experience was smooth."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Outstation Locations",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-outstation-cabs"
        },
        "keywords": "Pune Outstation Cab Services, Pune Outstation Taxi Booking, Pune Outstation Car Rental, Pune Outstation Chauffeur-Driven Cabs, Pune Outstation One-Way Taxi, Pune Outstation Round Trip Cabs, Pune Outstation Luxury Taxi, Pune Outstation Self-Drive Car Rental, Pune Outstation Travel Packages, Pune Outstation Private Car Hire, Pune Outstation Cabs, Outstation Taxi Service Pune, One Way Cab Pune, Best Outstation Cab Service in Pune, Outstation Cab Service in Pune, Outstation Car Rental Pune, Taxi in Pune for Outstation, Taxi Service in Pune for Outstation, Book Outstation Cabs Pune, Cab Booking in Pune for Outstation, Outstation Taxi in Pune, Outstation Taxi Service in Pune, Pune Airport to Kolhapur cab, Pune Car Rental Outstation, Pune to Gokarna Cab, Pune to Outstation Taxi"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/24.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Puneoutstationcab;